import React from 'react';
import DataTable from 'react-data-table-component';

const ListTemplate = ({ columns, data, actionButtons = [], loading = false }) => {
  // Map columns into DataTable's required format
  const tableColumns = [
    ...columns.map((column) => ({
      name: column.label,
      selector: (row) => row[column.value], // Access data based on column value key
      sortable: true, // Optional: Enable sorting for this column
    })),
    ...(actionButtons.length > 0
      ? [
          {
            name: 'Actions',
            cell: (row) => (
              <>
                {actionButtons.map((action) => (
                  <button
                    key={action.label}
                    onClick={() => action.handler(row.id)}
                    disabled={loading}
                    style={{ margin: '0 5px' }}
                  >
                    {loading ? 'Loading...' : action.label}
                  </button>
                ))}
              </>
            ),
            ignoreRowClick: true, // Prevent row click from triggering action cell
            allowOverflow: true,
            button: true,
          },
        ]
      : []), // Include the "Actions" column only if actionButtons has items
  ];

  return (
    <DataTable
      columns={tableColumns}
      data={data}
      progressPending={loading} // Display loading state
      highlightOnHover
      pagination // Optional: Enable pagination
      responsive
      dense
    />
  );
};

export default ListTemplate;
